import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';  // ✅ import useAuth
import logo from '../assets/giffypedialogo.png';

const CMSHeader = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();  // ✅ use logout from context

  const handleLogout = () => {
    logout();                  // ✅ clear auth state + localStorage
    navigate('/adminlogin');   // redirect to login page
  };

  return (
    <>
    <header className="cms-header bg-white p-3">
      <div className="header-content flex items-center justify-between">
        
        {/* Logo */}
        <h1>
          <img src={logo} alt="Giffypedia Logo" className="h-10 cursor-pointer"
            onClick={() => navigate('/dashboard')} />
        </h1>

        {/* Navigation Menus */}
        <nav className="flex items-center space-x-6">
          <button 
            className="text-gray-700 hover:text-blue-600 font-medium"
            onClick={() => navigate('/dashboard')}
          >
            Dashboard
          </button>
          <button 
            className="text-gray-700 hover:text-blue-600 font-medium"
            onClick={() => navigate('/articleupload')}
          >
            News
          </button>

          {/* Logout */}
          <button 
            className="logout-button flex items-center bg-red-500 text-white px-3 py-1 rounded-lg hover:bg-red-600 transition"
            onClick={handleLogout}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-5 w-5 inline-block mr-1" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" 
              />
            </svg>  
            Logout
          </button>
        </nav>
      </div>
      
    </header>
     <hr></hr>
     </>
   
  );
};

export default CMSHeader;
